import React, { useEffect, useState } from "react";
import CardBg from "../assets/images/card-bg.webp";
import QR from "../assets/images/QR.svg";
import LEAPColour from "../assets/images/LEAP_Colour.svg";
import Close from "../assets/images/X.svg";

import Button from "./Button";
import { useSelector } from "react-redux";
import Spinner from "./Spinner";
function ConfirmationCard({
  onClick,
  selectedTours,
  bookingsByDate,
  setSelectedTours,
}) {
  const [mainData, setMainData] = useState();
  const [isCloseLoaded, setIsCloseLoaded] = useState(false);
  const [isLogoLoaded, setIsLogoLoaded] = useState(false);
  const [isQRLoaded, setIsQRLoaded] = useState(false);
  const newAttendanceData = useSelector((state) => state?.attendance?.data);

  const { categories } = useSelector((state) => state.categoriesAfterBooking);

  const { details } = useSelector((state) => state.toursDetailsAfterBooking);

  const handleCloseClick = () => {
    onClick();
    setSelectedTours([]);
  };

  useEffect(() => {
    if (Object.entries(bookingsByDate || {}).length > 0) {
      const itemsToUpdate = Object.entries(bookingsByDate)
        ?.map(
          (data, index) => data[1]?.[index]?.items // Access the first item directly from each group
        )
        ?.flat();

      setMainData(itemsToUpdate);
    }
  }, [bookingsByDate]);

  const tours = [
    { title: "GOVERNMENTS", name: "tour 1", time: "01.00 TO 01.45" },
    { title: "TECH 2", name: "tour 2", time: "02.00 TO 02.45" },
    // { title: "TECH 2", name: "tour 2", time: "02.00 TO 02.45" },
    // { title: "TECH 2", name: "tour 2", time: "02.00 TO 02.45" },
    // { title: "TECH 2", name: "tour 2", time: "02.00 TO 02.45" },
  ];
  const dynamicWidth =
    selectedTours?.length !== 1 ? `${selectedTours?.length * 230}px` : "";
  const divStyle = {
    backgroundImage: `url(${CardBg})`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "auto", // Keeps the image at its original size
    backgroundPosition: "center",
    display: "inline-block",
    objectFit: "cover", // Shrinks the div to fit the image width
  };
  const formatDate = (inputDate) => {
    const date = new Date(inputDate); // Parse the input date
    const options = { month: "long", day: "numeric" }; // Format options
    const formattedDate = new Intl.DateTimeFormat("en-US", options).format(
      date
    );

    // Add ordinal suffix to the day
    const day = date.getDate();
    const ordinalSuffix = (n) => {
      const s = ["th", "st", "nd", "rd"];
      const v = n % 100;
      return s[(v - 20) % 10] || s[v] || s[0];
    };

    return `${formattedDate}${ordinalSuffix(day)}`;
  };

  const formatTimeTo12Hour = (time24) => {
    const [hour, minute] = time24.split(":");
    const hours = parseInt(hour, 10);
    const suffix = hours >= 12 ? "PM" : "AM";
    const hours12 = hours % 12 || 12;
    return `${hours12}:${minute} ${suffix}`;
  };

  const convertTimeRangeToAMPM = (timeRange) => {
    const convertToAMPM = (timeStr) => {
      const [hours, minutes] = timeStr.split(":")?.map(Number);
      const period = hours >= 12 ? "PM" : "AM";
      const adjustedHour = hours % 12 || 12; // Convert 24-hour format to 12-hour
      return `${adjustedHour}:${minutes.toString().padStart(2, "0")} ${period}`;
    };

    const [startTime, endTime] = timeRange?.split(" to ");
    const startAMPM = convertToAMPM(startTime);
    const endAMPM = convertToAMPM(endTime);
    return `${startAMPM} to ${endAMPM}`;
  };

  return (
    <div className="leap-h-full !leap-relative leap-mx-auto leap-w-[35rem]">
      {/* <img
        src={CardBg}
        alt="Card"
        className="leap-w-auto leap-h-auto leap-min-h-[65rem]  leap-object-cover leap-rounded-xl"
        style={{ width: dynamicWidth }} // Dynamic width for image
      /> */}

      <div
        className="!leap-absolute leap-p-5 leap-rounded-xl leap-bg-white leap-w-[86%] leap-h-[90%] leap-top-1/2 leap-left-1/2 leap-transform leap--translate-x-1/2 leap--translate-y-1/2"
        style={{
          background:
            "linear-gradient(180deg, #EB3DF7 0%, #3B29AB 50%, #73FAFD 100%)",
        }}
      >
        <div className="leap-absolute  leap-overflow-auto leap-p-5 leap-rounded-xl leap-bg-white leap-w-[98%] leap-h-[99%] leap-top-1/2 leap-left-1/2 leap-transform leap--translate-x-1/2 leap--translate-y-1/2">
          <img
            src={newAttendanceData?.qr_code_url}
            alt="QR"
            className="leap-hidden"
            onLoad={() => setIsQRLoaded(true)}
          />
          <img
            src={LEAPColour}
            alt="LEAPColour"
            className="leap-mx-auto leap-mt-9"
            loading="lazy"
            onLoad={() => setIsLogoLoaded(true)}
          />
          {isCloseLoaded && isLogoLoaded && isQRLoaded ? (
            <>
              <div className="">
                <h1 className="leap-uppercase leap-bg-clip-text leap-text-center leap-bg-[linear-gradient(180deg,_#EB3DF7_0%,_#3B29AB_50%,_#73FAFD_100%)] leap-text-5xl leap-font-bold leap-mt-6 leap-text-transparent">
                  TOUR
                </h1>
                <h1 className="custom-gradient-border  leap-relative leap-text-[25px] md:leap-text-[45px] leap-font-bold  leap-text-center leap-uppercase leap-text-white">
                  Confirmed
                  {/* <span className="leap-absolute leap-inset-0 leap-text-[45px] leap-font-bold leap-text-transparent leap-bg-clip-text leap-bg-[linear-gradient(180deg,_#EB3DF7_0%,_#3B29AB_50%,_#73FAFD_100%)] -leap-z-10  leap-pointer-events-none leap-select-none leap-border-[3px] leap-border-transparent leap-border-solid">
              confirmed
            </span> */}
                </h1>
                {/* <h1 className=" leap-text-center leap-text-4xl leap-font-bold">
              {selectedTours?.length > 0
                ? formatDate(selectedTours[0]?.date)
                : "No date available"}
            </h1> */}
              </div>

              <img
                src={newAttendanceData?.qr_code_url}
                alt="QR"
                className="leap-mx-auto leap-mt-9 leap-w-[200px] md:leap-w-[250px] lg:leap-w-[300px]"
                loading="lazy"
              />

              <div className="leap-mt-12 leap-flex leap-flex-col leap-justify-center leap-items-center">
                {selectedTours.length > 0 &&
                  selectedTours?.map((tour, index) => (
                    <React.Fragment key={index}>
                      <div
                        // Ensure each child has a unique key
                        className="leap-min-w-[130px] leap-flex leap-flex-col leap-text-center leap-gap-3 leap-justify-center"
                      >
                        <span className="leap-text-[#3B29AB] leap-font-bold leap-text-base leap-uppercase">
                          {tour.category}
                        </span>
                        <span className="leap-text-[#73FAFD] leap-font-bold leap-text-base leap-uppercase">
                          {tour.title}
                          {/* Dynamically display tour number */}
                        </span>
                        <span className="leap-font-semibold">
                          {convertTimeRangeToAMPM(tour.time)}
                        </span>
                        {/* Replace with dynamic time if available */}
                      </div>
                      {selectedTours.length > 1 && (
                        <div className="leap-w-[20vh] leap-mt-3 leap-mb-6 leap-h-[1px] leap-bg-gradient-to-r leap-from-[#EB3DF7] leap-via-[#3B29AB] leap-to-[#73FAFD] leap-mx-auto"></div>
                      )}
                    </React.Fragment>
                  ))}

                {mainData &&
                  mainData?.map((tour, index) => (
                    <React.Fragment key={index}>
                      <div
                        // Ensure each child has a unique key
                        className="leap-min-w-[130px] leap-flex leap-flex-col leap-text-center leap-gap-3 leap-justify-center"
                      >
                        <span className="leap-text-[#3B29AB] leap-font-bold leap-text-base leap-uppercase">
                          {/* {tour?.tour_id?.find(categories) return} */}

                          {categories?.data?.find(
                            (cat) => cat?.id == tour?.category_ids
                          )?.title || "Category Not Found"}
                        </span>
                        <span className="leap-text-[#73FAFD] leap-font-bold leap-text-base leap-uppercase">
                          {details?.data?.find(
                            (name) => name?.id == tour?.tour_id
                          )?.name || "Category Not Found"}
                          {/* Dynamically display tour number */}
                        </span>
                        <span className="leap-font-semibold">
                          {formatTimeTo12Hour(tour?.start_time)}
                          <span>to</span>
                          {formatTimeTo12Hour(tour?.end_time)}
                        </span>
                      </div>

                      <div className="leap-w-[20vh] leap-my-2 leap-h-[1px] leap-bg-gradient-to-r leap-from-[#EB3DF7] leap-via-[#3B29AB] leap-to-[#73FAFD]"></div>
                    </React.Fragment>
                  ))}
              </div>

              <div className="leap-mt-9 leap-flex leap-justify-center leap-items-center">
                {newAttendanceData?.qr_code_url && (
                  <a
                    download={"Image.png"}
                    href={newAttendanceData?.qr_code_url}
                  >
                    <Button
                      text="Show QR"
                      bgColor="#73FAFD"
                      textColor="black"
                      customStyles="leap-uppercase !leap-h-[70px] !leap-font-semibold"
                    />
                  </a>
                )}
              </div>
            </>
          ) : (
            <div className="leap-my-auto leap-flex leap-flex-col leap-justify-center leap-items-center leap-h-full">
              <Spinner />
            </div>
          )}
        </div>
        <button className="" onClick={handleCloseClick}>
          <img
            src={Close}
            alt="Close"
            className="leap-absolute  leap-top-[20px]  leap-left-[25px]"
            loading="lazy"
            onLoad={() => setIsCloseLoaded(true)}
          />
        </button>
      </div>
    </div>
  );
}

export default ConfirmationCard;
// background: linear-gradient(180deg,_#EB3DF7_0%,_#3B29AB_50%,_#73FAFD_100%)
